
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `روی «باز کردن در مرورگر…» ضربه بزنید`,
's182ab2d6c997515f': `برای تجربه گسترده و دسترسی آسان آن را به صفحه اصلی خود اضافه کنید.`,
's224cbcec014ef6b5': `در نوار پایین دکمه (Share) را  بزنید`,
's233af3b7eb5e0364': `افزودن به صفحه اصلی`,
's37a9e8aec5713460': `بیشتر`,
's4c3161035f3a1413': `روی منو فشار دهید`,
's4e1e10a6ca408245': `روی "Add to Home screen" ضربه بزنید`,
's6196153c4b0c1ea0': `نصب`,
's633502f7cff4f847': `مرورگر خود را باز کنید`,
's681e399d63311fba': `نمایش گالری`,
's6d14a4f70ba4e3cf': `اگر آیکون اشتراک‌گذاری وجود ندارد، روی منو فشار دهید`,
's922329d6f6213590': `افزودن به (Dock)`,
's9c63a79ffcc2a3a3': `روی «افزودن به صفحه اصلی» ضربه بزنید`,
'sa2d71bfd9525168d': `روی «افزودن به Dock» ضربه بزنید`,
'sa5ef80b4bb9b39f8': `کمتر`,
'sb527eca1c1d7e7be': `منوی مرورگر درون‌برنامه‌ای را باز کنید`,
'sba52286c21552a4e': `برای تجربه گسترده و دسترسی آسان آن را بر روی دستگاه خود نصب کنید.`,
'sc16e00a7a8b2fde2': `بازگشت`,
'scdaf4bbff76674c8': `افزودن به (Home Screen)`,
'sd18a5b85f599ff3c': `لینک کپی‌شده را در Safari باز کنید`,
'se72fc3a84f9b51c3': `برای کپی لینک ضربه بزنید`,
'se740f75b95a51807': `برای تجربه گسترده و دسترسی آسان آن را به Dock خود اضافه کنید.`,
'sfa6c42cdf48d93d2': `اما این مرورگر از این قابلیت پشتیبانی نمی‌کند. برای ادامه، لینک را در یک مرورگر خارجی باز کنید.`,
'sfb78526365796a41': `در منوی اشتراک‌گذاری روی «مشاهده بیشتر» ضربه بزنید`,
'sfea652f6580ff086': ` این سایت دارای قابلیت اپلیکیشن است. `,
    };
  